import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';

const usualFlow = [
  'cars',
  'review',
  'reservation',
  'confirmation',
];

@Injectable({
  providedIn: 'root'
})
export class CarPreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: Function): Observable<any> {
    // Pre-loading (after current is loaded and compiled) all chunks
    // which are after current in usual user flow,
    // all other chunks are loaded on demand.
    // This allows speed up first start thanks to lazy load without
    // losing speed of navigation between pages and without loading
    // unnescessary chunks (all routes out of usual flow will not pre-load anything)
    const path = location.pathname;
    const index = (!path || path === '/')
      ? 0
      : usualFlow.findIndex(item => location.pathname.startsWith(`/${item}`));

    if (~index && usualFlow.slice(index).includes(route.path)) {
      return load();
    }

    return of(null);
  }
}
